import { useQuery } from "@tanstack/react-query";
import { api } from "./client.js";

export interface CalendarDay {
  date: string;
  count: number;
  itemIds: string[];
}

export interface CalendarLoadResponse {
  days: CalendarDay[];
  items: Array<{ id: string; displayName: string; cron: string }>;
}

export function useCalendarLoad(fromIso: string, toIso: string) {
  return useQuery({
    queryKey: ["calendar", fromIso, toIso],
    queryFn: () =>
      api<CalendarLoadResponse>("/api/calendar/load", {
        query: { from: fromIso, to: toIso },
      }),
    staleTime: 60 * 1000,
  });
}
